import styled from "styled-components";
import { colors } from "../element/elements.js";

export const Styles = styled.div`
.mobile-menu-area {
    background: ${colors.bg2};
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    padding :10px;
    z-index: 999;
    transition: all 0.3s ease;

    .mb-topbar {
        border-bottom: 1px solid ${colors.black2};
        transition: all 0.3s ease;
        overflow: hidden;
        max-height: 50px;

        .topbar-item {
            p {
                font-size: 13px;
                color: ${colors.text1};
                padding: 8px 0;

                i {
                    font-size: 16px;
                    color: ${colors.green};
                    vertical-align: text-top;
                    margin-right: 5px;
                }
            }

            ul {
                padding: 8px 0;

                li {
                    a {
                        font-size: 13px;
                        color: ${colors.green};
                        font-weight: 500;
                        text-transform: uppercase;

                        &:hover {
                            color: #ffffff;
                        }
                    }

                    &:nth-child(2) {
                        color: ${colors.text1};
                    }
                }
            }
        }
    }

    .mb-logo-area {
        padding: 10px 10px;
        transition: all 0.3s ease;

        .mb-logo-box {
            .hm-button {
                margin-top: 8px;
                margin-right: 35px;
                position: relative;

                a#mb-sidebar-btn {
                    i {
                        font-size: 20px;
                        font-weight: 700;
                        color: ${colors.green};
                    }
                }

                @media (max-width: 480px) {
                    margin-top: 6px;
                    margin-right: 8px;

                    &:before {
                        content: none;
                    }
                }
            }
                
        }
                        .mb-search-box {
    .login-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: 35px;
        padding: 0 15px;
        border-radius: 5px;
        background: ${colors.green};
        color: #ffffff;
        font-size: 14px;
        font-weight: 500;
        text-decoration: none;
        transition: 0.3s ease;

        i {
            margin-right: 6px;
            font-size: 16px;
        }

        &:hover {
            background: #0e9e67; /
            color: #fff;
        }

        @media(max-width: 480px) {
            padding: 0 10px;
            font-size: 13px;
        }

        @media(max-width: 320px) {
            display: none;
        }
    }
}
            
    }

    &.scrolled {
        .mb-topbar {
            max-height: 0;
            opacity: 0;
            padding: 0;
            border-bottom: none;
        }

        .mb-logo-area {
            padding: 12px 0;
        }
    }

    @media (max-width: 767px) {
        display: block;
    }
}

// .mb-sidebar {
//     background: #ffffff;
//     height: 100%;
//     width: 320px;
//     position: fixed;
//     top : 0;
//     left: -320px;
//     overflow-y: auto;
//     z-index: 9999;
//     transition: all 400ms cubic-bezier(0.785,0.135,0.15,0.86);
//     display: none;
//     .mb-sidebar-heading {
//         background: ${colors.gr_bg};
//         padding: 25px;
//         h5 {
//             color: #ffffff;
//             text-transform: uppercase;
//         }
//         a#close-mb-sidebar {
//             i {
//                 font-size : 22px;
//                 color : #ffffff;
//             }
//         }
//     }
//     .mb-sidebar-menu {
//         padding: 25px;
//         .mb-menu-item {
//             border-top: 1px solid ${colors.border1};
//             &:last-child {
//                 border-bottom: 1px solid ${colors.border1};
//             }
//             button.mb-menu-button {
//                 border       : none;
//                 background   : transparent;
//                 display      : block;
//                 width        : 100%;
//                 padding      : 10px 0;
//                 text-align   : left;

//                 p {
//                     font-size  : 14px;
//                     color      : ${colors.black1};
//                     text-transform: uppercase;
//                     i {
//                         font-size: 13px;
//                         float: right;
//                         border: 1px solid ${colors.border3};
//                         border-radius: 25px;
//                         padding: 3px;
//                     }
//                     &:hover {
//                         color      : ${colors.green};
//                         i {
//                             border-color : ${colors.green};
//                         }
//                     }
//                 }
//             }

//             .mb-menu-content {
//                 max-height: 0;
//                 overflow  : hidden;
//                 transition: max-height 0.2s ease-in-out;

//                 ul {
//                     li {
//                         border-top: 1px solid ${colors.border1};
//                         a {
//                             font-size  : 13px;
//                             color      : ${colors.black2};
//                             display    : block;
//                             padding    : 10px 0;
//                             padding-left: 15px;
//                             &:hover {
//                                 color      : ${colors.green};
//                             }
//                         }
//                     }
//                 }
//             }

//             .mb-menu-content.show {
//                 max-height: 100%;
//             }
//         }
//     }

//     @media(max-width: 767px) {
//         display : block;
//     }

//     @media(max-width: 480px) {
//         max-width: 275px;
//     }
// }

.mb-sidebar {
    background: #ffffff;
    height: 100%;
    width: 320px;
    position: fixed;
    top: 0;
    left: -320px;
    overflow-y: auto;
    z-index: 9999;
    transition: all 400ms cubic-bezier(0.785, 0.135, 0.15, 0.86);
    display: none;

    .mb-sidebar-heading {
        background: ${colors.gr_bg};
        padding: 25px;

        h5 {
            color: #ffffff;
            text-transform: uppercase;
            margin-bottom: 0;
        }

        a#close-mb-sidebar {
            i {
                font-size: 22px;
                color: #ffffff;
            }
        }
    }

    .mb-sidebar-menu {
        padding: 25px 25px 15px;

        li {
            list-style: none;
            border-top: 1px solid ${colors.border1};

            &:last-child {
                border-bottom: 1px solid ${colors.border1};
            }

            a {
                display: block;
                padding: 12px 0;
                font-size: 14px;
                font-weight: 500;
                color: ${colors.black1};
                text-transform: uppercase;
                text-decoration: none;
                transition: all 0.3s ease;

                &:hover {
                    color: ${colors.green};
                    padding-left: 8px;
                }
            }

            &.active {
                a {
                    color: ${colors.black1};
                }
            }
        }
    }

    @media (max-width: 767px) {
        display: block;
    }

    @media (max-width: 480px) {
        width: 275px;
        left: -275px;
    }
}

.mb-sidebar.opened {
    left: 0 !important;
}

.mb-sidebar-overlay {
    position        : fixed;
    left            : 0;
    top             : 0;
    height          : 100%;
    width           : 100%;
    display         : block;
    background-color: rgba(0, 0, 0, 0.8);
    z-index         : 1111;
    visibility      : hidden;
    opacity         : 0;
    transition      : 0.3s ease;
}

.mb-sidebar-overlay.visible {
    visibility: visible;
    opacity   : 1;
}
`;